// extracted by mini-css-extract-plugin
export default {"container":"AdminConfigAlerts_container__QaqBP"};